import { Tag } from 'nhsuk-react-components';
import StatusTag from 'components/ReportStatus';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema.ts';
import { SUMMARY_REPORT_REVIEW_STATUSES } from 'schemas/SummaryReport.schema.ts';

interface ISummaryReportHeaderStatusProps {
  isCurrent: boolean;
  iterationStatus: ITERATION_STATUS;
  summaryReportStatus: SUMMARY_REPORT_REVIEW_STATUSES;
  isLatestSummaryReport: boolean;
}

export default function SummaryReportHeaderStatus({
  isCurrent,
  iterationStatus,
  summaryReportStatus,
  isLatestSummaryReport,
}: ISummaryReportHeaderStatusProps) {
  if (
    isLatestSummaryReport
    && (
      isCurrent
    || iterationStatus === ITERATION_STATUS.SENT_TO_NHS_NOTIFY
    )
  ) {
    return <StatusTag status={iterationStatus as ITERATION_STATUS} />;
  }

  return (
    <>
      <Tag color="grey">Archived</Tag>
      {' '}
      {summaryReportStatus && <StatusTag status={summaryReportStatus} />}
    </>
  );
}
